import { Routes } from '@angular/router';
import { AppLayout } from './layout/app.layout';
import { OrganizzazioneResolver } from './modules/organizzazione/organizzazione.resolver';

export const routes: Routes = [
  {
    path: 'pagina-non-trovata',
    loadComponent: () =>
      import('./modules/page-not-found/page-not-found.component').then(
        (m) => m.PageNotFoundComponent,
      ),
  },
  {
    path: '',
    component: AppLayout,
    children: [
      {
        path: ':orgSlug',
        loadComponent: () =>
          import('./modules/organizzazione/organizzazione.component').then(
            (m) => m.OrganizzazioneComponent,
          ),
        resolve: {
          org: OrganizzazioneResolver,
        },
      },
      {
        path: '',
        redirectTo: 'oms',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'pagina-non-trovata',
  },
];
